(function () {
  function initAnnouncementBar(root) {
    const bar = root.matches('.announcement-bar') ? root : root.querySelector('.announcement-bar');
    if (!bar) return;

    const swiperEl = bar.querySelector('.announcement-bar__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const autoplay = bar.dataset.autoplay === 'true' && slideCount > 1;
    const delay = Number(bar.dataset.autoplaySpeed) || 5000;

    new Swiper(swiperEl, {
      loop: slideCount > 1,
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: slideCount > 1,
      autoplay: autoplay ? { delay, disableOnInteraction: false } : false,
    });
  }

  function initAll() {
    document.querySelectorAll('.announcement-bar').forEach(initAnnouncementBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBar(event.target);
  });
})();
